import React, { useState } from "react";

const FALLBACK_IMG =
    "https://images.unsplash.com/photo-1574958269340-fa927503f3dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc4NTE4MjY0MXww&ixlib=rb-4.1.0&q=85";

export default function PhotoCarousel({ photos, alt }) {
    const images = photos && photos.length > 0 ? photos : [FALLBACK_IMG];
    const [index, setIndex] = useState(0);

    const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);
    const next = () => setIndex((i) => (i + 1) % images.length);

    return (
        <div className="relative w-full aspect-[4/3] overflow-hidden bg-muted" data-testid="center-photo-carousel">
            <img src={images[index]} alt={alt} className="w-full h-full object-cover" />

            {images.length > 1 && (
                <>
                    <button
                        type="button"
                        onClick={prev}
                        aria-label="Previous photo"
                        className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white w-8 h-8 flex items-center justify-center text-lg"
                        data-testid="carousel-prev"
                    >
                        ‹
                    </button>
                    <button
                        type="button"
                        onClick={next}
                        aria-label="Next photo"
                        className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white w-8 h-8 flex items-center justify-center text-lg"
                        data-testid="carousel-next"
                    >
                        ›
                    </button>
                    <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
                        {images.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setIndex(i)}
                                aria-label={`Go to photo ${i + 1}`}
                                className={`h-1.5 rounded-full transition-all duration-300 ${
                                    i === index ? "w-5 bg-white" : "w-1.5 bg-white/50"
                                }`}
                                data-testid={`carousel-dot-${i}`}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
